"use client";

import {useContext, useEffect} from "react";
import { LayoutContext } from "../layout-context-container";

export default function IndicationsTray({fullContent, shortContent, children = null}) {
  const {indicationsMobileStateCollapsed, setIndicationsMobileStateCollapsed} = useContext(LayoutContext);

  const mobileToggleClass = indicationsMobileStateCollapsed ? 'indications__toggle collapsed' : 'indications__toggle'

  useEffect(() => {
    let travel = 0;

    function handleScroll() {
      if (travel >= 10) {
        // show header after scrolling 10 pixels
        setIndicationsMobileStateCollapsed(true);
        travel = 0;
      } else {
        travel++;
      }
    }

    const state = sessionStorage.getItem("indicationsMobileStateCollapsed");
    setIndicationsMobileStateCollapsed(state === "true");
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [setIndicationsMobileStateCollapsed]);

  function toggleIndications(){
    const newState = !indicationsMobileStateCollapsed;
    sessionStorage.setItem("indicationsMobileStateCollapsed", newState.toString());
    setIndicationsMobileStateCollapsed(newState);
  }

  return (
    <>
      <div className="indications-tray">
        <div className={mobileToggleClass} onClick={toggleIndications}></div>
        <div className="container container--px-12">
          <p>
            {(!indicationsMobileStateCollapsed && fullContent)}
            {(indicationsMobileStateCollapsed && shortContent)}
            {(indicationsMobileStateCollapsed && <span className="indications__see-more" onClick={toggleIndications}> see more</span>)}
          </p>

        </div>
      </div>
      {children}
    </>
  );
}